import * as Actions from '../../actions/app'

const initialState = {
  loading_user_vouchers_for_sale: false,
  user_vouchers_for_sale: [],
}

const userVouchersReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_USER_VOUCHER_FOR_SALE: {
      return {
        ...state,
        loading_user_vouchers_for_sale: action.payload.loading ?? state.loading_user_vouchers_for_sale,
        user_vouchers_for_sale: action.payload.data ?? state.user_vouchers_for_sale,
      }
    }
    default: {
      return state
    }
  }
}

export default userVouchersReducer
